import React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '../../Form/Fields/TextField';
import { getLanguage } from '../../../features/app/selectors';
import SpacedTextField from '../../Form/Fields/SpacedTextField';

const TextTabContent = () => {
  const language = useSelector(getLanguage);
  return (
    <Grid container spacing={4}>
      <Grid item sm={12} md={6}>
        <SpacedTextField
          label="ppi.iFoodIDLabel"
          dataField="referencedIngredientData.itemCode"
          extentionField="formulaVersion"
          disabled
        />
        {/* <SpacedTextField
          label="ppi.legacyiFoodIDLabel"
          dataField="referencedIngredientData.legacyFormulaCode"
          disabled
        /> */}
        <TextField
          label="ppi.presentationNameLabel"
          dataField={`info.${language}.presentationName`}
          helperText="ppi.presentationNameHelperText"
        />
        <TextField
          label="ppi.additionalInfoLabel"
          dataField={`info.${language}.additionalInformation`}
          helperText="ppi.additionalInfoHelperText"
          multiline
          rows={3}
        />
      </Grid>
    </Grid>
  );
};

export default TextTabContent;
